import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { indexWorkflows, workflowQueryKeys, WorkflowsIndexParams } from 'services/api/workflows';

// A chip's badge count, without pulling the chip's full result set: page_size: 1 gets back
// meta.totalRecords for the cost of a single row. Its own query (not a `select` off the main
// list query) because a chip's count params usually differ from the currently-selected chip's
// list params — the two aren't the same request.
export default function useWorkflowCount(params: WorkflowsIndexParams, enabled = true) {
  const countParams = { ...params, page: 1, pageSize: 1 };
  const query = useQuery({
    queryKey: workflowQueryKeys.list(countParams),
    queryFn: ({ signal }) => indexWorkflows(countParams, signal),
    select: (data) => data.meta.totalRecords,
    // A new key (a date range commit, a checkbox) would otherwise flash every chip to (0) until
    // its own round trip lands; the previous number is the better interim.
    placeholderData: keepPreviousData,
    enabled,
  });

  return query.data ?? 0;
}
